import {
  CandleFetchParams,
  CandlePoint,
  ExchangeCandleRestAdapter,
} from "../../candle.types";
import { normalizeCandleSymbol } from "../../candle-symbols";
import { toHyperliquidInterval } from "../../candle-intervals";
import { dedupeCandles } from "./rest-adapter.utils";

interface HyperliquidCandle {
  t: number;
  o: string;
  h: string;
  l: string;
  c: string;
  v?: string;
}

const HYPERLIQUID_INFO_URL = "https://api.hyperliquid.xyz/info";

export const hyperliquidCandlesRestAdapter: ExchangeCandleRestAdapter = {
  async fetchCandles(params: CandleFetchParams): Promise<CandlePoint[]> {
    const coin = normalizeCandleSymbol("hyperliquid", params.symbol);
    const response = await fetch(HYPERLIQUID_INFO_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type: "candleSnapshot",
        req: {
          coin,
          interval: toHyperliquidInterval(params.interval),
          startTime: params.startTime,
          endTime: params.endTime ?? Date.now(),
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`hyperliquid: request failed (${response.status})`);
    }

    const payload = (await response.json()) as HyperliquidCandle[];
    const candles: CandlePoint[] = payload.map((item) => ({
      startTime: Number(item.t),
      openPrice: item.o,
      highPrice: item.h,
      lowPrice: item.l,
      closePrice: item.c,
      volume: item.v ?? "0",
    }));

    return dedupeCandles(candles);
  },
};

